import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ChatbotPage from "./components/ChatbotPage";
import AuthPage from "./components/AuthPage";
import EditChatbotPage from "./components/EditChatbotPage";
import ProtectedRoute from "./components/ProtectedRoute";
import { Navigate } from "react-router-dom";
import "./global.css";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/*" element={<Navigate to={"/login"}></Navigate>} />
        <Route exact path="/login" element={<AuthPage />} />
        <Route
          exact
          path="/chatbot"
          element={
            <ProtectedRoute>
              <ChatbotPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/chatbot/edit"
          element={
            <ProtectedRoute>
              <EditChatbotPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
